module.exports = __webpack_public_path__ + "img/app_three.c4b5926a.png";